import React, { useEffect, useState } from "react";
import Ratings from "react-star-ratings";
import { Row, Col } from "react-bootstrap";
import PropTypes from "prop-types";
import Fonts from "../assets/Fonts";
import { Button } from "../Button/Button";
import Colors from "../assets/Colors";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";

import classes from "./reviewBox.module.css";
import { coachDemoImg, messageIconBlack } from "../../constant/imagePath";

export const ReviewBox = ({ reviewData, onClick1, onClick2 }) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  let name = reviewData?.user?.displayName.split(" ");
  return (
    <div className={` ${[classes.box].join(" ")}`}>
      <Row>
        <Col
          xl={isMobile ? 12 : reviewData?.type ? 9 : 12}
          md={isMobile ? 12 : reviewData?.type ? 8 : 12}
          sm={12}
        >
          <Col md={12} className={` ${[classes.userDetails].join(" ")}`}>
            <div>
              <img
                src={reviewData?.user.photo}
                className={`${[classes.profile].join(" ")}`}
              />
            </div>
            <div className={`${classes.detailsAndRating}`}>
              <div className={`${classes.nameAndTime}`}>
                <h6
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.h7,
                    lineHeight: "24px",
                    fontFamily: "inter-600",
                  }}
                >
                  {`${name[0]} ${name[1].charAt(0)}`}
                  {/* {reviewData?.user?.displayName}  */}
                </h6>
                <span
                  className={`${[classes.break].join(" ")}`}
                  style={{ backgroundColor: Colors.neutralShadesOfPinkSwan }}
                />
                <p
                  className={`${[classes.date].join(" ")}`}
                  style={{
                    color: Colors.neutralShadesOfNero,
                    ...Fonts.p1,
                  }}
                >
                  {reviewData?.createdAt}
                </p>
              </div>
              <Ratings
                numberOfStars={5}
                starRatedColor={Colors.mainShadeOfRed}
                starEmptyColor={Colors.neutralShadesOfGainsboro}
                rating={reviewData?.rating}
                starDimension="16px"
                starSpacing={3}
              />
            </div>
          </Col>
          <Col md={12}>
            <p
              className={`${[classes.reviewText].join(" ")}`}
              style={{ color: Colors.neutralShadesOfDimGray, ...Fonts.p1 }}
            >
              {reviewData?.text}
            </p>
          </Col>
          <Col md={12} className={`${[classes.btnsBox].join(" ")}`}>
            {reviewData?.tags?.map((item) => {
              return (
                <Button
                  primary={false}
                  disabled={false}
                  label={item}
                  customStyle={{
                    width: "max-content",
                    padding: "8px 16px 8px 16px",
                    height: "36px",
                    ...Fonts.p2,
                    marginRight: "8px",
                  }}
                />
              );
            })}
          </Col>
        </Col>
        {reviewData?.type && (
          <Col
            xl={isMobile ? 12 : reviewData?.type ? 3 : 12}
            md={isMobile ? 12 : reviewData?.type ? 4 : 12}
            sm={12}
          >
            {reviewData?.type === "view-lesson" && (
              <div className={classes.btns}>
                <Button
                  size={"Medium"}
                  icon={messageIconBlack}
                  onClick={onClick1}
                />
                <Button
                  size={"Medium"}
                  primary={false}
                  label={"View lesson info"}
                  customStyle={{
                    width: "max-content",
                    padding: "24px 14px",
                    marginLeft: "8px",
                  }}
                  onClick={onClick2}
                />
              </div>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
};
ReviewBox.propTypes = {
  reviewData: PropTypes.object,
  type: PropTypes.string,
  onClick1: PropTypes.func,
  onClick2: PropTypes.func,
};
ReviewBox.defaultProps = {
  reviewData: {
    user: {
      photo: coachDemoImg,
      displayName: "Michael Baumgardner",
      distance: "0.6 m away",
      city: "New York",
      lat: "",
      lng: "",
      aboutMe:
        "Professionally experienced knowledgeable coach of athletes from youths through collegiate level in tennisgiate level in tennis",
      price: 75,
      rating: 5,
      sport: "Tennis",
      createdAt: "March 10,2022",
    },
    // Review Details
    text: "This is my first review",
    createdAt: "March 10,2022",
    rating: 4,
    tags: ["Friendly", "Focused"],
  },
};
